import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useCallback } from 'react';
import { apiDocumentServiceRepository } from 'services/repositories/implementations/ApiDocumentServiceRepository';
import { QueryKeys } from 'utils/queryKeys';

interface UseDocumentExpiryDateProps {
  contentId: string;
}

export type DocumentExpiryDateDataReturn = {
  expire_at: string | null;
};

export const useDocumentExpiryDate = ({ contentId }: UseDocumentExpiryDateProps) => {
  const getDocumentExpiryDate = useQuery({
    queryKey: QueryKeys.getDocumentExpiryAt(contentId),
    queryFn: (): Promise<DocumentExpiryDateDataReturn> =>
      apiDocumentServiceRepository.getDocumentData({ contentId }).then((response) => ({
        expire_at: response?.expireAt?.split('T')[0] ?? null,
      })),
    enabled: !!contentId,
  });

  const isDocumentExpired = useCallback(() => {
    const currentDate = dayjs();
    const { data: expiredDate, isLoading } = getDocumentExpiryDate;

    return {
      isExpired: expiredDate && currentDate.isAfter(expiredDate.expire_at),
      isLoading,
    };
  }, [getDocumentExpiryDate]);

  return {
    getDocumentExpiryDate,
    isDocumentExpired,
  };
};
